import React from 'react'
import { Grid, Hidden, Button, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@material-ui/core'
import MaterialInputable from './MaterialInputable'
import MaterialSelectable from './MaterialSelectable'
import SplitButton from './SplitButton'
import FormValidator from './FormValidator'
import PropTypes from 'prop-types'
import api from '../api'

export default class Tire extends React.Component {
	/**
	 * Default constructor object
	 * @param {props} props - the initial props object
	 * @returns {void} returns void
	 * @public
	 */
	constructor(props) {
		super(props)

		this.validator = this.getValidator(props)

		this.state = {
			open: false,
			tireApplications: [],
			tireBrands: [],
			tireSizes: [],
			tireTreads: [],
			loadRanges: [],
			validation: this.validator.valid()
		}

		this.addComment = this.addComment.bind(this)
		this.duplicateTire = this.duplicateTire.bind(this)
		this.onCloseDialog = this.onCloseDialog.bind(this)
		this.onPriorityChange = this.onPriorityChange.bind(this)
		this.onAxleTypeChange = this.onAxleTypeChange.bind(this)
		this.onApplicationChange = this.onApplicationChange.bind(this)
		this.onRequiredActivityChange = this.onRequiredActivityChange.bind(this)
		this.onTireTypeChange = this.onTireTypeChange.bind(this)
		this.onTireBrandChange = this.onTireBrandChange.bind(this)
		this.onTireSizeChange = this.onTireSizeChange.bind(this)
		this.onTreadChange = this.onTreadChange.bind(this)
		this.isValid = this.isValid.bind(this)
	}

	/**
	 * The componentDidMount event for the component
	 * @param {event} event - the event object
	 * @returns {void} returns void
	 * @public
	 */
	async componentDidMount() {
		const fleetLocationId = this.props.domain.fleetLocationId
		const isRetread = this.props.domain.tireType
		const brandId = this.props.domain.tireBrand
		const tireSize = this.props.domain.tireSize
		const tireTread = this.props.domain.tireTread

		const tireApplications = await this.getTireApplications(fleetLocationId)
		const tireBrands = await this.getTireBrands(isRetread)
		const tireSizes = await this.getTireSizes(brandId)
		const tireTreads = await this.getTireTreads(brandId, tireSize)
		const loadRanges = await this.getLoadRanges(brandId, tireSize, tireTread)

		this.setState({
			tireApplications: tireApplications,
			tireBrands: tireBrands,
			tireSizes: tireSizes,
			tireTreads: tireTreads,
			loadRanges: loadRanges,
		})
	}

	/**
	 * Performs validation of the data in the dialog.
	 * @returns {FormValidator} the current validation object
	 * @public
	 */
	getValidator() {
		return new FormValidator([
			{
				prop: {
					object: 'domain',
					name: 'priority'
				},
				field: "priority",
				method: 'isEmpty',
				validWhen: false,
				message: 'Priority is required',
				isDisabled: this.props.disabled || this.props.domain.readOnly
			},
			{
				prop: {
					object: 'domain',
					name: 'priority'
				},
				field: "priority",
				method: 'isInt',
				validWhen: true,
				args: [{gt: 0, allow_leading_zeroes: false}],
				message: 'Priority must be numeric',
				isDisabled: this.props.disabled || this.props.domain.readOnly
			},
			{
				prop: {
					object: 'domain',
					name: 'axleType'
				},
				field: "axleType",
				method: 'isEmpty',
				validWhen: false,
				message: 'Axle Type is required',
				isDisabled: this.props.disabled || this.props.domain.readOnly
			},
			{
				prop: {
					object: 'domain',
					name: 'application'
				},
				field: "application",
				method: 'isEmpty',
				validWhen: false,
				message: 'Application is required',
				isDisabled: this.props.disabled || this.props.domain.readOnly
			},
			{
				prop: {
					object: 'domain',
					name: 'requiredActivity'
				},
				field: "requiredActivity",
				method: 'isEmpty',
				validWhen: false,
				message: 'Required Activity is required',
				isDisabled: this.props.disabled || this.props.domain.readOnly
			},
			{
				prop: {
					object: 'domain',
					name: 'tireType'
				},
				field: "tireType",
				method: 'isEmpty',
				validWhen: false,
				message: 'Tire Type is required',
				isDisabled: this.props.disabled || this.props.domain.readOnly
			},
			{
				prop: {
					object: 'domain',
					name: 'tireBrand'
				},
				field: "tireBrand",
				method: 'isEmpty',
				validWhen: false,
				message: 'Brand is required',
				isDisabled: this.props.disabled || this.props.domain.readOnly
			},
			{
				prop: {
					object: 'domain',
					name: 'tireBrand'
				},
				field: "tireBrand",
				method: 'isInt',
				validWhen: true,
				args: [{ gt: 0, allow_leading_zeroes: false }],
				message: 'Brand is required',
				isDisabled: this.props.disabled || this.props.domain.readOnly
			},
			{
				prop: {
					object: 'domain',
					name: 'tireBrand'
				},
				field: "tireBrand",
				method: this.isPrimaryMAST,
				validWhen: true,
				message: 'First 2 priorities must be Michelin brands',
				isDisabled: this.props.disabled || this.props.domain.readOnly || !this.props.isNafa
			},
			{
				prop: {
					object: 'domain',
					name: 'tireSize'
				},
				field: "tireSize",
				method: 'isEmpty',
				validWhen: false,
				message: 'Size is required',
				isDisabled: this.props.disabled || this.props.domain.readOnly
			},
			{
				prop: {
					object: 'domain',
					name: 'tireSize'
				},
				field: "tireSize",
				method: 'isInt',
				validWhen: true,
				args: [{ gt: 0, allow_leading_zeroes: false }],
				message: 'Size is required',
				isDisabled: this.props.disabled || this.props.domain.readOnly
			},
			{
				prop: {
					object: 'domain',
					name: 'tread'
				},
				field: "tread",
				method: 'isEmpty',
				validWhen: false,
				message: 'Tread is required',
				isDisabled: this.props.disabled || this.props.domain.readOnly
			},
			{
				prop: {
					object: 'domain',
					name: 'tread'
				},
				field: "tread",
				method: 'isInt',
				validWhen: true,
				args: [{ gt: 0, allow_leading_zeroes: false }],
				message: 'Tread is required',
				isDisabled: this.props.disabled || this.props.domain.readOnly
			},
			{
				prop: {
					object: 'domain',
					name: 'loadRange'
				},
				field: "loadRange",
				method: 'isEmpty',
				validWhen: false,
				message: 'Load Range is required',
				isDisabled: this.props.disabled || this.props.domain.readOnly
			},
			{
				prop: {
					object: 'domain',
					name: 'loadRange'
				},
				field: "loadRange",
				method: 'isInt',
				validWhen: true,
				args: [{ gt: 0, allow_leading_zeroes: false }],
				message: 'Load Range is required',
				isDisabled: this.props.disabled || this.props.domain.readOnly
			},
		])
	}

	/**
	 * The onCloseEvnt event for the component
	 * @param {string} value - the value of the field
	 * @param {state} state - the current state object
	 * @param {props} props - the current prop object
	 * @returns {boolean} returns true if the brand is MAST and priority is 1 or 2
	 * @public
	 */
	isPrimaryMAST(value, state, props) {
		const priority = props.domain.priority ? props.domain.priority.toString() : ''

		if (['1','2'].includes(priority)) {
			const michelinBrands = props.tireBrandTypeOptions.filter(b => {
				return b.isMichelin
			}).map(b => b.id.toString())

			if (! michelinBrands.includes(value)) {
				return false
			}
		}

		return true
	}

	/**
	 * Returns the list of valid tire applications based on account
	 * 
	 * @param {boolean} fleetLocationId
	 */
	async getTireApplications(fleetLocationId) {
		let result = this.props.tireApplicationTypeOptions

		if (fleetLocationId) {
			const tireApplicationListResponse = await api.service('tireApplicationList').find({
				query: {
					fleet_location_id: { $eq: fleetLocationId },
					$limit: 2000,
				}
			})

			if (tireApplicationListResponse.total > 0) {
				result = [...this.props.tireApplicationTypeOptions, ...tireApplicationListResponse.data]
			}
		}

		return result
	}

	/**
	 * Returns the list of valid tire brands based on isRetread
	 * 
	 * @param {boolean} isRetread 
	 */
	getTireBrands(isRetread) {
		const result = this.props.tireBrandTypeOptions.filter(tire => tire.isRetread === (isRetread === undefined ? false : isRetread))

		return result
	}

	/**
	 * Return the list of valid tireSizes based on the brandId. If no brandId is specified, returns all tireSizes
	 * 
	 * @param {number} brandId 
	 */
	async getTireSizes(brandId) {
		let result = this.props.tireSizeTypeOptions

		if (brandId) {
			const tireBrandSizesResponse = await api.service('tireBrandSizes').find({
				query: { 
					brandId: { $eq: brandId },
					$limit: 2000,
				}
			})

			if (tireBrandSizesResponse.total > 0) {
				result = this.props.tireSizeTypeOptions.filter( el => {
					return tireBrandSizesResponse.data.some( f => {
						return f.sizeId === el.id
					})
				})
			}
		}

		return result
	}

	/**
	 * Returns the list of valid tireTreads based on the brandId and tireSize. If no brandId is specified, returns all tireTreads.
	 * If only a brandId is specified, then it limits based on the brandId
	 * 
	 * @param {number} brandId 
	 * @param {string} tireSize 
	 */
	async getTireTreads(brandId, tireSize) {
		let result = this.props.tireTreadTypeOptions

		if (brandId) {
			result = this.props.tireTreadTypeOptions.filter(tread => tread.brandId === brandId)
		}

		if (brandId && tireSize) {
			const tireBrandSizesTreadsResponse = await api.service('tireBrandSizesTreads').find({
				query: { 
					brandId: { $eq: brandId },
					sizeId: { $eq: tireSize },
					$limit: 400,
				}
			})

			if (tireBrandSizesTreadsResponse.total > 0) {
				result = this.props.tireTreadTypeOptions.filter(el => {
					return tireBrandSizesTreadsResponse.data.some(f => {
						return f.treadId === el.id
					})
				})
			}
		}

		return result
	}

	/**
	 * Returns the list of valid loadRanges based on the brandId, tireSize and tireTread
	 * 
	 * @param {number} brandId 
	 * @param {string} tireSize 
	 * @param {string} tireTread 
	 */
	async getLoadRanges(brandId, tireSize, tireTread) {
		let result = this.props.loadRangeTypeOptions

		if (brandId && tireSize && tireTread) {
			const tireBrandSizeTreadLoadRangeResponse = await api.service('tireBrandSizeTreadLoadRange').find({
				query: {
					brandId: { $eq: brandId },
					sizeId: { $eq: tireSize },
					treadId: { $eq: tireTread },
					isGenericLoadRange: { $eq: false },
					$limit: 200,
				}
			})

			if (tireBrandSizeTreadLoadRangeResponse.total > 0) {
				result = this.props.loadRangeTypeOptions.filter(el => {
					return tireBrandSizeTreadLoadRangeResponse.data.some(f => {
						return f.loadRangeId === el.id || f.loadRangeId === null
					})
				})
			}
		}

		return result
	}

	/**
	 * The onCloseEvnt event for the component
	 * @returns {void} returns void
	 * @public
	 */
	onCloseDialog() {
		this.setState({
			open: false,
			tireApplications: this.props.tireApplicationTypeOptions,
			tireBrands: this.props.tireBrandTypeOptions,
			tireSizes: this.props.tireSizeTypeOptions,
			tireTreads: this.props.tireTreadTypeOptions,
			loadRanges: this.props.loadRangeTypeOptions
		})
	}

	/**
	 * Add a comment by opening the dialog
	 * @returns {void} returns void
	 * @public
	 */
	addComment() {
		this.setState({
			open: true
		})
	}

	/**
	 * copy the current tire preference into a new item
	 */
	duplicateTire() {
		if (this.props.onDuplicate) {
			this.props.onDuplicate(this.props.domain)
		}
	}

	/**
	 * Update the validation object value for 'item'
	 * @param {string} item - the item in the validation object to update
	 * @param {boolean} isInvalid - the new state for isInvalid
	 * @param {string} message - the new message to be displayed
	 * @returns {void} returns void
	 * @public
	 */
	updateValidation(item, isInvalid = false, message = '') {
		let validation = Object.assign({}, this.state.validation)
		validation[item].isInvalid = isInvalid
		validation[item].message = message

		this.setState({
			validation: validation
		})
	}

	/**
	 * The onChange event for the otherType
	 * @param {event} event - the event object
	 * @returns {void} returns void
	 * @public
	 */
	onPriorityChange(event) {
		this.updateValidation('priority')

		if (this.props.onChange) {
			this.props.onChange(event)
		}
	}

	/**
	 * The onChange event for the otherType
	 * 
	 * @param {event} event - the event object
	 * @returns {void} returns void
	 * @public
	 */
	onAxleTypeChange(event) {
		this.updateValidation('axleType')

		if (this.props.onChangeSelect) {
			this.props.onChangeSelect(event)
		}
	}

	/**
	 * The onChange event for the otherType
	 * 
	 * @param {event} event - the event object
	 * @returns {void} returns void
	 * @public
	 */
	onApplicationChange(event) {
		this.updateValidation('application')

		if (this.props.onChangeSelect) {
			this.props.onChangeSelect(event)
		}
	}

	/**
	 * The onChange event for the otherType
	 * 
	 * @param {event} event - the event object
	 * @returns {void} returns void
	 * @public
	 */
	onRequiredActivityChange(event) {
		this.updateValidation('requiredActivity')

		if (this.props.onChangeSelect) {
			this.props.onChangeSelect(event)
		}
	}

	/**
	 * The tireTypeChange event for the component
	 * 
	 * @param {event} event - the event object
	 * @returns {void} returns void
	 * @public
	 */
	onTireTypeChange(event) {
		let isRetread = this.props.domain.tireType

		if (event) {
			isRetread = event.target.value
		}

		this.setState({
			tireBrands: this.getTireBrands(isRetread)
		})
		
		this.updateValidation('tireType')

		if (this.props.onChangeSelect) {
			this.props.onChangeSelect(event)
		}
	}

	/**
	 * The tireBrandChange event for the component
	 * 
	 * @param {event} event - the event object
	 * @returns {void} returns void
	 * @public
	 */
	async onTireBrandChange(event) {
		let brandId = this.props.domain.tireBrand

		if ( event ) {
			brandId = event.target.value
		}

		const tireSizes = await this.getTireSizes(brandId)
		const tireTreads = await this.getTireTreads(brandId)

		this.setState({
			tireSizes: tireSizes,
			tireTreads: tireTreads,
		})

		this.updateValidation('tireBrand')

		if (this.props.onChangeSelect) {
			this.props.onChangeSelect(event)
		}
	}

	/**
	 * The onChange event for the otherType
	 * @param {event} event - the event object
	 * @returns {void} returns void
	 * @public
	 */
	async onTireSizeChange(event) {
		let brandId = this.props.domain.tireBrand
		let tireSize = this.props.domain.tireSize

		if (event) {
			tireSize = event.target.value
		}

		const tireTreads = await this.getTireTreads(brandId, tireSize)

		this.setState({
			tireTreads: tireTreads
		})

		this.updateValidation('tireSize')

		if (this.props.onChangeSelect) {
			this.props.onChangeSelect(event)
		}
	}

	/**
	 * The onChange event for the otherType
	 * @param {event} event - the event object
	 * @returns {void} returns void
	 * @public
	 */
	async onTreadChange(event) {
		let brandId = this.props.domain.tireBrand
		let tireSize = this.props.domain.tireSize
		let tireTread = this.props.domain.tireTread

		if (event) {
			tireTread = event.target.value
		}

		const loadRanges = await this.getLoadRanges(brandId, tireSize, tireTread)

		this.setState({
			loadRanges: loadRanges
		})

		this.updateValidation('tread')

		if (this.props.onChangeSelect) {
			this.props.onChangeSelect(event)
		}
	}

	/**
	 * Performs validation of the data in the dialog.
	 * @returns {boolean} is the current object valid?
	 * @public
	 */
	async isValid() {
		const validation = await this.validator.validate(this.state, this.props)
		this.setState({ validation })

		return validation.isValid
	}

	render() {
		const { index, displayIndex, disabled, domain, onRemove, onChange, onChangeSelect } = this.props
		const { tireApplications, tireBrands, tireSizes, tireTreads, loadRanges, validation } = this.state

		if (domain.isDelete) {
			return null
		}

		this.validator = this.getValidator()

		let menuItems = [
			{ icon: 'swap_horizontal_circle', label: 'Duplicate', onClick: this.duplicateTire, disabled: domain.readOnly },
			{ icon: 'delete', label: 'Delete', onClick: () => onRemove(index), disabled: domain.readOnly },
		]

		if (process.env.NODE_ENV !== 'production') { 
			menuItems.push({ icon: 'check_circle', label: 'Validate', onClick: this.isValid })
		}

		return (
			<React.Fragment>
				<Grid container spacing={1} style={domain.isCreate ? ((displayIndex % 2 === 1) ? { background: '#faf8cd' } : { background: '#fffee9' }) : (displayIndex % 2 === 1) ? { background: '#efefef' } : null}>
					<Grid item xs={2} sm={4} md={2} lg={1}>
						<MaterialInputable
							required
							value={domain.priority} 
							name={index + "_priority"} 
							label="Priority"
							disabled={disabled || domain.readOnly}
							error={validation.priority.isInvalid}
							errorMessage={validation.priority.message}
							onChange={this.onPriorityChange} />
					</Grid>
					<Grid item xs={5} sm={4} md={2}>
						<MaterialSelectable 
							required
							value={domain.axleType || ''} 
							name={index + "_axleType"} 
							disabled={disabled || domain.readOnly}
							label="Axle Type" 
							error={validation.axleType.isInvalid}
							errorMessage={validation.axleType.message}
							onChange={this.onAxleTypeChange} 
							options={this.props.axleTypeOptions} />
					</Grid>
					<Grid item xs={5} sm={4} md={2} lg={3}>
						<MaterialSelectable 
							required
							value={domain.application || ''} 
							name={index + "_application"} 
							disabled={disabled || domain.readOnly}
							label="Application" 
							error={validation.application.isInvalid}
							errorMessage={validation.application.message}
							onChange={this.onApplicationChange}
							code={'applicationId'}
							description={'applicationDesc'}
							options={tireApplications} />
					</Grid>
					<Grid item xs={7} sm={6} md={4}>
						<MaterialSelectable 
							required
							value={domain.requiredActivity || ''} 
							name={index + "_requiredActivity"} 
							label="Required Activity" 
							disabled={disabled || domain.readOnly}
							error={validation.requiredActivity.isInvalid}
							errorMessage={validation.requiredActivity.message}
							onChange={this.onRequiredActivityChange} 
							options={this.props.requiredActivityTypeOptions} />
					</Grid>
					<Hidden mdDown>
						<Grid item lg={2}></Grid>
					</Hidden>
					<Grid item xs={5} sm={3} md={2} lg={1}>
						<MaterialSelectable 
							required
							value={domain.tireType} 
							name={index + "_tireType"} 
							label="Tire Type" 
							disabled={disabled || domain.readOnly}
							error={validation.tireType.isInvalid}
							errorMessage={validation.tireType.message}
							onChange={this.onTireTypeChange} 
							options={this.props.tireTypeOptions} />
					</Grid>
					<Grid item xs={7} sm={3} md={2}>
						<MaterialSelectable 
							required
							value={domain.tireBrand || ''} 
							disabled={(disabled || domain.readOnly) || domain.tireType === undefined}
							name={index + "_tireBrand"} 
							label="Brand" 
							error={validation.tireBrand.isInvalid}
							errorMessage={validation.tireBrand.message}
							onChange={this.onTireBrandChange} 
							options={tireBrands} />
					</Grid>
					<Grid item xs={5} sm={3} md={2}>
						<MaterialSelectable 
							required
							value={domain.tireSize || ''} 
							disabled={(disabled || domain.readOnly) || domain.tireBrand === undefined}
							name={index + "_tireSize"} 
							label="Size" 
							error={validation.tireSize.isInvalid}
							errorMessage={validation.tireSize.message}
							onChange={this.onTireSizeChange} 
							options={tireSizes} />
					</Grid>
					<Grid item xs={7} sm={4}>
						<MaterialSelectable 
							required
							value={domain.tread || ''} 
							name={index + "_tread"}
							disabled={(disabled || domain.readOnly) || domain.tireBrand === undefined}
							label="Tread" 
							error={validation.tread.isInvalid}
							errorMessage={validation.tread.message}
							onChange={this.onTreadChange} 
							options={tireTreads} />
					</Grid>
					<Grid item xs={5} sm={2} lg={1}>
						<MaterialSelectable 
							required
							value={domain.loadRange || ''} 
							name={index + "_loadRange"} 
							disabled={(disabled || domain.readOnly) || domain.tireSize === undefined}
							label="Load Range" 
							error={validation.loadRange.isInvalid}
							errorMessage={validation.loadRange.message}
							onChange={onChangeSelect} 
							options={loadRanges} />
					</Grid>
					<Grid item xs={1}>
						{!(disabled || domain.readOnly) &&
							<SplitButton
								action={{
									icon: 'comment',
									color: (domain.comments === '' || domain.comments === null) ? 'primary' : 'secondary',
									hint: (domain.comments === '' || domain.comments === null) ? "Click to enter comment" : domain.comments,
									onClick: this.addComment
								}}
								menuItems={menuItems}
							/>
						}
					</Grid>
				</Grid>
				
				<Dialog
					open={this.state.open}
					onClose={this.onCloseDialog}
					fullWidth={true}
					maxWidth={'sm'}>
					<DialogTitle>Additional Comments</DialogTitle>
					<DialogContent>
						<DialogContentText>
							Please enter your comment below.
						</DialogContentText>
						<MaterialInputable 
							value={domain.comments === null ? '' : domain.comments} 
							name={this.props.index + "_comments"} 
							onChange={onChange} />
					</DialogContent>
					<DialogActions>
						<Button onClick={this.onCloseDialog} color="primary">Save</Button>
					</DialogActions>
				</Dialog>
			</React.Fragment>
		)
	}
}

Tire.propTypes = {
	classes: PropTypes.object,
	index: PropTypes.number,
	displayIndex: PropTypes.number,
	disabled: PropTypes.bool,
	isNafa: PropTypes.bool,
	domain: PropTypes.object,
	recordCount: PropTypes.number,
	onRemove: PropTypes.func,
	onChange: PropTypes.func,
	onComment: PropTypes.func,
	onDuplicate: PropTypes.func,
	axleTypeOptions: PropTypes.array,
	requiredActivityTypeOptions: PropTypes.array,
	tireApplicationTypeOptions: PropTypes.array,
	tireTypeOptions: PropTypes.array,
	tireBrandTypeOptions: PropTypes.array,
	tireSizeTypeOptions: PropTypes.array,
	tireTreadTypeOptions: PropTypes.array,
	loadRangeTypeOptions: PropTypes.array,
	onChangeSelect: PropTypes.func
}

Tire.defaultProps = {
	isNafa: true,
	disabled: false
}


// WEBPACK FOOTER //
// ./src/components/Tire.js